export enum StepPath {
  LOSS_LOCATION_DETAILS = "loss_location_details",
  MISSING_POLICY_DETAILS = "missing_policy_details",
  ENTER_CLAIMS_DETAILS = "enter_claims_details",
  UPLOAD_CLAIM_DOCUMENTS = "upload_claim_documents",
  WHO_IS_REPORTING_CLAIM = "who_is_reporting_claim",
  CLAIM_SUBMITTED_SUCCESSFULLY = "claim_submitted_successfully",
  POLICY_DETAILS = "policy_details",
  SUMMARY = "summary",
}

export enum SummaryStepHistory {
  LOSS_LOCATION_DETAILS = -4,
  UPLOAD_CLAIM_DOCUMENTS = -2,
  CLAIM_REPORTER = -1,
  POLICY_DETAILS = -5,
}
